import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WhatsAppOptInCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
  authorizedRep?: boolean;
}

export default function WhatsAppOptInCheckbox({
  value,
  onChange,
  disabled,
}: WhatsAppOptInCheckboxProps) {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id='whatsapp-opt-in-checkbox'
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label={t('formInputs.whatsappOptInLabel')}
    />
  );
}
